import { render } from "./VisualizarImplementacoes.vue?vue&type=template&id=5007d48a"
import script from "./VisualizarImplementacoes.vue?vue&type=script&lang=js"
export * from "./VisualizarImplementacoes.vue?vue&type=script&lang=js"

import "./VisualizarImplementacoes.vue?vue&type=style&index=0&id=5007d48a&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__